import React, {useContext, useEffect, useState} from 'react';
import { useNavigate, useParams, Link } from "react-router-dom";
import { InputContext } from '../contexts/InputContext';
import BotonVolver from '../components/BotonVolver';
import resourcesServices from '../services/resourcesServices';
import { errorMessage } from '../errorHandler';
import TextControl from '../components/customizedInputs/TextControl';
import SelectControl from '../components/customizedInputs/SelectControl';
import { pdf } from '@react-pdf/renderer';
import RptDeclaracionJuradaObligado from '../components/reportes/RptDeclaracionJuradaObligado';

const RegistroPublicoObligado = () => {
  const tipo_doc = ["dni", "lc", "le"]
  const estado_civil = ["soltero", "casado", "viudo", "divorciado"]

  const navigate = useNavigate();
  const [authInformation] = useContext(InputContext)
  const [saving, setSaving] = useState(false);
  const [adjunto, setAdjunto] = useState(null);
  const [finalizado, setFinalizado] = useState(false);
  const [resource, setResource] = useState(false);
  const [preferencias, setPreferencias] = useState(false);
  const [declaracionJurada, setDeclaracionJurada] = useState(false);
  const [valido, setValido] = useState(false);
  const [renderHTML, setRenderHTML] = useState(false)
  const [step, setStep] = useState(3);


  useEffect(() => {
   if( authInformation.autenticado === true && authInformation.rol === 'MesaEntrada'){
      setRenderHTML(false)
      navigate(`/`);
    } else {
      setRenderHTML(true)
      // Obtengo campos vacios de un usuario nuevo
      nuevoObligado()
    }
  }, [authInformation]);

  const generarDDJJObligado = async () => {
      const blob = await pdf( <RptDeclaracionJuradaObligado resource={resource} preferencias={preferencias} declaracionJurada={declaracionJurada}  /> ).toBlob();
      const url = URL.createObjectURL(blob);
      window.open(url, '_blank'); // Abre el PDF en una nueva pestaña
  };

  const nuevoObligado = async () => {
    try {
      setSaving(true)

      const data = await resourcesServices.nuevoResource('usuarios');
      const data_ddjj = await resourcesServices.nuevoResource('declaraciones_juradas');
      setPreferencias(data.preferencias_usuario)
      delete data.preferencias_usuario
      setResource(data)
      setDeclaracionJurada(data_ddjj)
   
      setSaving(false)

    } catch (error) {
      setSaving(false)
      errorMessage(error)
    }
  };

  const getTipo = (valor) => {
    if (Array.isArray(valor)) return 'array';
    if (valor === null) return 'null';
    if (typeof valor === 'object') return 'object';
    return 'primitivo';
  }

  const validarCampos = async () => {
    try {
      setSaving(true)
      setValido(false)

      const copyResource = {...resource}
      copyResource.preferencias_usuario_attributes = {...preferencias}
      copyResource.declaracion_juradas_attributes = {...declaracionJurada}

      const attributeName = 'usuario'
      const formData =  new FormData();

      for(const [key, value] of Object.entries(copyResource)){
          if(value !== null){
              if(key === "adjunto"){
                  for(let i = 0; i < value.length; i++){
                      formData.append(`${attributeName}[${key}]`, value.item(i), value.item(i).name)
                  }
              } else {
                const tipoValor = getTipo(value)
                if(tipoValor === 'object'){
                  for(const [keyB, valueB] of Object.entries(value)){
                    const tipoValorB = getTipo(valueB)
                    formData.append(`${attributeName}[${key}][${keyB}]`, tipoValorB === 'null' ? '' : valueB)
                  }
                } else if (tipoValor === 'primitivo' || tipoValor === 'null') {
                  formData.append(`${attributeName}[${key}]`, tipoValor === 'null' ? '' : value )
                }
              }
          }
      }

      formData.append(`skip_some_user_attributes`, true)

      await resourcesServices.crearResource('usuarios/validarContenidoObligado', formData);

      setSaving(false)
      setValido(true)
      alert("Datos Validos")

    } catch (error) {
      setSaving(false)
      setValido(false)
      errorMessage(error)
    }
  };

  const guardarObligado = async () => {
    try {
      setSaving(true)

      const copyResource = {...resource}
      copyResource.preferencias_usuario_attributes = {...preferencias}
      copyResource.declaracion_juradas_attributes = {...declaracionJurada}
      // Solo cuando el obligado se registra, hardcodeo el estado de la declaracion jurada
      copyResource.declaracion_juradas_attributes.estado = "aprobado"

      const attributeName = 'registro_pdf'
      const formData =  new FormData();
      for(const [key, value] of Object.entries(copyResource)){
          if(value !== null){
              if(key === "adjunto"){
                  for(let i = 0; i < value.length; i++){
                    formData.append(`${attributeName}[${key}]`, value.item(i), value.item(i).name)
                  }
              } else {
                const tipoValor = getTipo(value)
                if(tipoValor === 'object'){
                  for(const [keyB, valueB] of Object.entries(value)){
                    const tipoValorB = getTipo(valueB)
                    formData.append(`${attributeName}[${key}][${keyB}]`, tipoValorB === 'null' ? '' : valueB)
                  }
                } else if (tipoValor === 'primitivo' || tipoValor === 'null') {
                  formData.append(`${attributeName}[${key}]`, tipoValor === 'null' ? '' : value )
                }
              }
          }
      }
      if(adjunto){
        formData.append(`${attributeName}[adjunto]`, adjunto)
      }

      await resourcesServices.crearResource('registro_pdfs', formData);

      setSaving(false)
      setFinalizado(true)
      alert("Información actualizada")

    } catch (error) {
      setSaving(false)
      errorMessage(error)
    }
  };

  const mismoDomicilioReal = () => {

    setPreferencias({...preferencias,
      ['calle_legal']: preferencias.calle_real,
      ['barrio_legal']: preferencias.barrio_real,
      ['localidad_legal']: preferencias.localidad_real,
      ['cp_legal']: preferencias.cp_real,
    })
  }

  const verificarEmail = () => {
    return resource.email && resource.email === resource.confirmar_email
  }

  const handleFormSubmit = (e) => {
    e.preventDefault()
    // guardarObligado()
    if(verificarEmail()){
      validarCampos()
    } else {
      alert("Ingrese su email y su verifique que la confirmación sea el mismo email.")
    }
  }

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setAdjunto(files[0])
  };

  const handleInputResource = (e) => {
    const { name, value } = e.target;

    setResource({...resource,
      [name]: value
    })
  }

  const handleInputPreferencias = (e) => {
    const { name, value } = e.target;

    setPreferencias({...preferencias,
      [name]: value
    })
  }

  const handleInputDeclaracionJurada = (e) => {
    const { name, value } = e.target;

    setDeclaracionJurada({...declaracionJurada,
      [name]: value
    })
  }

  return (
    <div>
      {renderHTML && (
        <>
        <h1>Registro de Obligado <BotonVolver /></h1>
        {
          resource && preferencias && declaracionJurada && (
          <form id="carouselExample" className='carousel slide' onSubmit={handleFormSubmit}>
            <div className='carousel-inner p-3'>
              <div className='carousel-item active'>
                <h5>Paso 1/2</h5>
                <div className="row mt-3">
                  <div className="col-6">
                    <div className="card mb-5">
                      <div className="card-body">
                        <h5 className="card-title">Información personal</h5>
                          <TextControl
                            value={resource.nombre}
                            name={'nombre'}
                            handleInput={handleInputResource}
                          />
                          <TextControl
                            value={resource.apellido}
                            name={'apellido'}
                            handleInput={handleInputResource}
                          />
                          <TextControl
                            value={preferencias.f_nacimiento}
                            name={'f_nacimiento'}
                            handleInput={handleInputPreferencias}
                            label={"Fecha Nacimiento"}
                            hasLabel={true}
                            type={"birthday"}
                          />
                          <SelectControl
                            value={preferencias.tipo_doc}
                            options={tipo_doc}
                            required={true}
                            name={'tipo_doc'}
                            handleInput={handleInputPreferencias}
                          />
                          <TextControl
                            value={resource.documento_identidad}
                            name={'documento_identidad'}
                            handleInput={handleInputResource}
                          />
                          <TextControl
                            value={preferencias.nacionalidad}
                            name={'nacionalidad'}
                            handleInput={handleInputPreferencias}
                          />
                          <TextControl
                            value={preferencias.telefono_particular}
                            name={'telefono_particular'}
                            handleInput={handleInputPreferencias}
                          />
                          <TextControl
                            value={preferencias.telefono_laboral}
                            name={'telefono_laboral'}
                            handleInput={handleInputPreferencias}
                          />
                          <SelectControl
                            value={preferencias.estado_civil}
                            options={estado_civil}
                            required={true}
                            name={'estado_civil'}
                            handleInput={handleInputPreferencias}
                          />
                          <TextControl
                            value={preferencias.nombre_conyuge}
                            name={'nombre_conyuge'}
                            handleInput={handleInputPreferencias}
                          />
                          <TextControl
                            value={preferencias.apellido_conyuge}
                            name={'apellido_conyuge'}
                            handleInput={handleInputPreferencias}
                          />

                      </div>
                    </div>

                    <div className="card mb-5">
                      <div className="card-body">
                        <h5 className="card-title">DDJJ</h5>
                          <div className="alert alert-success text-white" role="alert">
                            Ingrese su cargo actual. Una vez dado de alta, podrá agregar otros cargos.
                          </div>
                          <TextControl
                            value={declaracionJurada.cargo}
                            name={'cargo'}
                            handleInput={handleInputDeclaracionJurada}
                          />
                          <TextControl
                            value={declaracionJurada.organismo}
                            name={'organismo'}
                            handleInput={handleInputDeclaracionJurada}
                          />
                          <div className="alert alert-warning" role="alert">
                            Hacer saber que me desempeño/desempeñé en el cargo indicado precedentemente desde
                          </div>
                          <TextControl
                            value={declaracionJurada.f_cargo_desde}
                            name={'f_cargo_desde'}
                            handleInput={handleInputDeclaracionJurada}
                            hasLabel={true}
                            label={"Cargo Desde"}
                            type={"birthday"}
                          />
                          <TextControl
                            value={declaracionJurada.numero_alta_norma_legal}
                            name={'numero_alta_norma_legal'}
                            handleInput={handleInputDeclaracionJurada}
                          />
                          <div className="alert alert-warning" role="alert">
                            Si corresponde, hacer saber que me desempeño/desempeñé en el cargo indicado precedentemente hasta
                          </div>
                          <TextControl
                            value={declaracionJurada.f_cargo_hasta}
                            name={'f_cargo_hasta'}
                            handleInput={handleInputDeclaracionJurada}
                            hasLabel={true}
                            label={"Cargo Hasta"}
                            type={"birthday"}
                          />
                          <TextControl
                            value={declaracionJurada.numero_baja_norma_legal}
                            name={'numero_baja_norma_legal'}
                            handleInput={handleInputDeclaracionJurada}
                          />


                      </div>
                    </div>

                    <div className="card mb-5">
                      <div className="card-body">
                        <h5 className="card-title">Datos de Usuario</h5>
                          <TextControl
                            value={resource.email}
                            name={'email'}
                            handleInput={handleInputResource}
                            hasLabel={true}
                          />
                          <TextControl
                            value={resource.confirmar_email}
                            name={'confirmar_email'}
                            handleInput={handleInputResource}
                            hasLabel={true}
                          />

                      </div>
                    </div>

                  </div>
                  <div className="col-6">
                    <div className="card mb-5">
                      <div className="card-body">
                        <h5 className="card-title">Domicilio Real</h5>
                          <TextControl
                            value={preferencias.calle_real}
                            name={'calle_real'}
                            handleInput={handleInputPreferencias}
                            label={"Dirección (calle y nº)"}
                          />
                          <TextControl
                            value={preferencias.barrio_real}
                            name={'barrio_real'}
                            handleInput={handleInputPreferencias}
                            label={"Barrio"}
                          />
                          <TextControl
                            value={preferencias.localidad_real}
                            name={'localidad_real'}
                            handleInput={handleInputPreferencias}
                            label={"Localidad"}
                          />
                          <TextControl
                            value={preferencias.cp_real}
                            name={'cp_real'}
                            handleInput={handleInputPreferencias}
                            label={"Código Postal"}
                          />
                      </div>
                    </div>

                    <div className="d-grid gap-2 mb-3">
                      <button className="btn btn-info" onClick={() => mismoDomicilioReal()} type="button">Mismo Domicilio Real</button>
                    </div>


                    <div className="card mb-5">
                      <div className="card-body">
                        <h5 className="card-title">Domicilio Legal</h5>
                          <TextControl
                            value={preferencias.calle_legal}
                            name={'calle_legal'}
                            handleInput={handleInputPreferencias}
                            label={"Dirección (calle y nº)"}
                          />
                          <TextControl
                            value={preferencias.barrio_legal}
                            name={'barrio_legal'}
                            handleInput={handleInputPreferencias}
                            label={"Barrio"}
                          />
                          <TextControl
                            value={preferencias.localidad_legal}
                            name={'localidad_legal'}
                            handleInput={handleInputPreferencias}
                            label={"Localidad"}
                          />
                          <TextControl
                            value={preferencias.cp_legal}
                            name={'cp_legal'}
                            handleInput={handleInputPreferencias}
                            label={"Código Postal"}
                          />
                      </div>
                    </div>

                  </div>
                </div>

                <button disabled={saving} className="btn btn-danger mt-3 me-3" type="submit">
                  {saving && (<span className="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>)}
                  <span role="status">Verificar</span>
                </button>
                {/* <button onClick={() => generarDDJJObligado()} className="btn btn-danger mt-3 me-3" type="button">
                  Reporte
                </button> */}
                
                { valido && (
                  <button disabled={step===1} className="btn btn-primary mt-3" data-bs-target="#carouselExample" data-bs-slide="next" type="button">Siguiente Paso</button>
                )
                }

              </div>
              <div className='carousel-item'>
                {finalizado ? (
                  <>
                  <h5>Finalizado</h5>
                  <div className='fs-5'>Le hemos enviado un correo a <b>{resource.email}</b></div>
                  </>
                ) : (
                  <>
                    <h5>Paso 2/2</h5>
                    { valido && (
                      <>
                      Descargue el documento, fírmelo y adjúntelo firmado <br />
                      <button onClick={() => generarDDJJObligado()} type="button" className="btn btn-primary mt-3" target='_blank'>Descargar Documento</button>
                      <div className="mt-3 mb-3">
                        Una vez firmado, adjúntelo aquí
                        <input
                          placeholder="Adjunte el documento interactivo"
                          className="form-control"
                          onChange={handleFileChange}
                          accept='.pdf'
                          name="adjunto"
                          type="file"
                          id="adjunto" />
                      </div>
                      </>
                      )
                    }
                    <hr className='mt-3 mb-3' />
                    <button className="btn btn-danger mt-3 me-3" data-bs-target="#carouselExample" data-bs-slide="prev" type="button">Volver</button>
                    {
                      <button onClick={guardarObligado} disabled={saving} className="btn btn-primary mt-3" type="button">
                        {saving && (<span className="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>)}
                        <span role="status">Finalizar</span>
                      </button>
                    }
                    </>
                  )}
              </div>

            </div>
            {/* <pre>{JSON.stringify(datosUsuario, null, 2)}</pre> */}
          </form>
          )
        }
        </>
      )}
    </div>
  );
};

export default RegistroPublicoObligado;